/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>authorization.service.ts</name>
///
/// <description>
///  
///  
///  
/// </description>
///
/// <author>Scott Grau</author>
/// <created>11 Jan 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 11Jan2017  1.0.0000         First cut 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { HydUser } from "../../models/user";
import { Rule } from "./rule.model";
import { UserAPIService, GroupUser, GroupModel, AccessLevel, MinAlertLevel } from '../../services/Crestron.HydrogenAPI.UserApi.service';

@Injectable()
export class AuthorizationService {

    private rules: Rule[]
    private groups: GroupModel[];

    constructor(
        private http: Http,
        private hydUser : HydUser, 
        private userClient: UserAPIService
    ) {
    
        console.log("AuthorizationService Constructor Called");
    }

    //----------------------------------------------------------
    //isAuthorized
    //----------------------------------------------------------
    isAuthorized(uiKey:String) : Observable<Boolean> {
        return Observable.create(observer => {

            if(this.rules == null)
            {
                  //  console.log("**********************Loading rules.json**************")
                    this.http.get('./app/models/rules.json')
                            .map((response: Response) => response.json())   
                            .subscribe(securityRules => { 
                                    this.rules = securityRules;
                                    observer.next(this.checkAccount(uiKey));
                                    observer.complete();
                            });

            }
            else
            {
                 observer.next(this.checkAccount(uiKey));
                 observer.complete();
            }

        } )


      
    }

     //----------------------------------------------------------
    //checkAccount
    //----------------------------------------------------------
     checkAccount(uiKey:String) : Boolean {                     
              
            let rule : Rule = this.rules.filter(securityRules => securityRules.UIKeys.includes(uiKey))[0];
            if(rule != undefined)
            {
                
                for(var i=0; i<this.hydUser.Roles.length;i++)
                {
                  //   console.log("**********************User Role : " + this.hydUser.Roles[i] + "  UIKey: " + uiKey + "*****************");
                    
                    if(rule.RoleIds.includes(this.hydUser.Roles[i])) {
                   //     console.log("**********************Authorized : " + this.hydUser.Roles[i] + " can access UIKey " + uiKey + "*****************");
                      return true;
                    }
                    
                }
            }
         //  console.log("**********************Not Authorized : Cannot access UIKey " + uiKey + "*****************");
          return false;
            
         // return true;
    }

    //----------------------------------------------------------
    //hasAccess
    //----------------------------------------------------------
     hasAccess(uiKey:String, groupID : String ) : Observable<Boolean> {
          return Observable.create(observer => {
                if(this.groups == null)
                {                    
                    this.userClient.getGroupsByAccountId(this.hydUser.AccountId)
                    .subscribe(results => {
                        console.log("**********************getGroupsByAccountId called User Account ID: " + this.hydUser.AccountId + "*****************");
                        this.groups = results;                    
                        observer.next(this.checkAccessLevel(uiKey, groupID));
                        observer.complete();
                    });

                }
                else {
                    observer.next(this.checkAccessLevel(uiKey, groupID));
                    observer.complete();
                }         
            });
            
    
     }


    //----------------------------------------------------------
    //checkAccessLevel
    //----------------------------------------------------------
    checkAccessLevel(uiKey:String, groupID : String ) : Boolean {
     try {
             
            //First Check regular RBAC 
            if(this.checkAccount(uiKey))
            {
                return true;
            }
            
            //Then Check Group Access Level Settings
            //Get Security Rule for UIKey 
            let rule : Rule = this.rules.find(securityRules => securityRules.UIKeys.includes(uiKey));
            if(rule != undefined)
            {                
                //Get Group for GroupID passed into function
                let group : GroupModel =  this.groups.find((nodes) => nodes.id == groupID);
                if(group != undefined && group != null)
                {
                    
                    let groupUser : GroupUser =  group.groupUsers.find((users) => users.userPrincipalName == this.hydUser.UserId);
                    if(groupUser != undefined && groupUser != null )  {
                        let userAccessLevel : AccessLevel = this.resolveInheritNode(this.groups, group.id );
                        if(userAccessLevel == AccessLevel.Administrator && rule.RoleIds.includes("GroupAdmin")) {
                            // console.log("**********************User can access UIKey " + uiKey + "*****************");
                            return true;
                        }
                        else if(userAccessLevel == AccessLevel.Tech && rule.RoleIds.includes("GroupTech" ) ) {
                         //   console.log("**********************User can access UIKey " + uiKey + "*****************");
                             return true;
                        }
                        else if(userAccessLevel == AccessLevel.Viewer && rule.RoleIds.includes("GroupViewer" ) ) {
                           //  console.log("**********************User can access UIKey " + uiKey + "*****************");
                             return true;
                        }
                        else
                        {
                           //  console.log("**********************User can NOT access UIKey " + uiKey + "*****************");

                            return false;
                        }                                               
                    }
                    else
                    {
                      //  console.log("-------------------NO ACCESS LEVELS DEFINED------------------");

                        if (group.groupParentId == null) {
                            return false;
                        }

                        let userAccessLevel: AccessLevel = this.resolveInheritForChildNode(this.groups, group.id);

                        if (userAccessLevel == AccessLevel.Administrator && rule.RoleIds.includes("GroupAdmin")) {
                            // console.log("**********************User can access UIKey " + uiKey + "*****************");
                            return true;
                        }
                        else if (userAccessLevel == AccessLevel.Tech && rule.RoleIds.includes("GroupTech")) {
                            //   console.log("**********************User can access UIKey " + uiKey + "*****************");
                            return true;
                        }
                        else if (userAccessLevel == AccessLevel.Viewer && rule.RoleIds.includes("GroupViewer")) {
                            //  console.log("**********************User can access UIKey " + uiKey + "*****************");
                            return true;
                        }
                        else {
                            //  console.log("**********************User can NOT access UIKey " + uiKey + "*****************");

                            return false;
                        }                                               

                    }
                }
                else 
                {
                  //  console.log("-------------------NO ACCESS LEVELS DEFINED------------------");
                    return false;
                }                  
            }      
            return false;
            
            
        }
        catch(ex)                                    
        {
            console.log("Exception has Occured : " + ex)
            return false;
        } 
       // return true;
     } 

     //----------------------------------------------------------
    //resolveInheritNode
    //----------------------------------------------------------
    resolveInheritNode(groups: GroupModel[], groupId: String) : number {
            console.log("-------------------resolveInheritNode Called------------------");
            let group: GroupModel = groups.find(n=>n.id == groupId);
            let groupUser: GroupUser = group.groupUsers.find(n=>n.userPrincipalName == this.hydUser.UserId)
            
            if(group == null) {
                 return AccessLevel.Viewer;
            }
            else if(groupUser.accessLevel == AccessLevel.Inherit && group.groupParentId == null  ) {
                return AccessLevel.Viewer;
            }
            //Access Level Found in recursion that is other than Inherit; return level upwards in callstack
            else if(groupUser.accessLevel != AccessLevel.Inherit) {
                return groupUser.accessLevel;
            }
            else {
                return this.resolveInheritNode(groups, group.groupParentId)
            }       
    }

    //----------------------------------------------------------
    //resolveInheritForChildNode
    //----------------------------------------------------------
    resolveInheritForChildNode(groups: GroupModel[], groupId: String): number {
        console.log("-------------------resolveInheritNode Called------------------");
        let group: GroupModel = groups.find(n => n.id == groupId);
        let groupUser: GroupUser = group.groupUsers.find(n => n.userPrincipalName == this.hydUser.UserId)


        if (groupUser == undefined)
        {
            if (group.groupParentId == null)
            {

                return AccessLevel.Viewer;
            }
            else
            {
                return this.resolveInheritForChildNode(groups, group.groupParentId)
            }
        }
        else if (group == null) {
            return AccessLevel.Viewer;
        }
        else if (groupUser.accessLevel == AccessLevel.Inherit && group.groupParentId == null) {
            return AccessLevel.Viewer;
        }
        //Access Level Found in recursion that is other than Inherit; return level upwards in callstack
        else if (groupUser.accessLevel != AccessLevel.Inherit) {
            return groupUser.accessLevel;
        }
        else {
            return this.resolveInheritForChildNode(groups, group.groupParentId)
        }
    }

    //----------------------------------------------------------
    //resetGroupAuthorizationData
    //----------------------------------------------------------
    resetGroupAuthorizationData(): void {
        this.userClient.getGroupsByAccountId(this.hydUser.AccountId)
            .subscribe(results => {
                this.groups = results;
            });
    }

}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authorization/shared/authorization.service.ts